import { fg } from '@atlassian/jira-feature-gating';

const jiv22469DevSummaryToMIAQRelayProvider = {
	get(): boolean {
		return fg('jiv-22469-dev-summary-to-miaq');
	},
};

export default jiv22469DevSummaryToMIAQRelayProvider;
